// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Quicksand-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Quicksand-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Quicksand-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Quicksand-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/Quicksand-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    box-sizing: border-box;
}

@font-face {
    font-family: 'Quicksand';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: 300;
    font-style: normal;
  }

@font-face {
    font-family: 'Quicksand';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }

@font-face {
    font-family: 'Quicksand';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: 500;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'Quicksand';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: 600;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'Quicksand';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
    font-weight: 700;
    font-style: normal;
  }




:root {
    --banner-height: 50px;
    --main-font: 'Quicksand', sans-serif;
    --incorrect-color: rgb(175, 175, 175);
    --streak-color: 251, 145, 24;
    --unsolved-color: rgb(255, 255, 255);
    --selection-blue: rgb(50, 115, 246);
    --unseen-blue: #3d88ed;
    --victory-modal-gray: rgb(160, 160, 160);
    --max-width: 500px;
    --modal-max-width: 300px;
    --turn-transition-duration: 500ms;
    --half-turn-transition-duration: 250ms;
    --letter-margin-rem: 0.3;
    --turn-indicator-width: calc(min(2.3vw, 0.7rem) + 1px);

    /* Light mode colors */
    --body-background-color-light: #ffffff;
    --overlay-background-color-light: rgba(255, 255, 255, 0.9);
    --default-text-color-light: black;
    --secondary-text-color-light: rgb(100, 100, 100);
    --default-button-background-color-light: lightgray;
    --default-button-text-color-light: black;
    --selected-color-light: black;
    --cell-outline-color-light: lightgray;
    --banner-shadow-color-light: lightgray;
    --unavailable-calendar-color-light: #f4f4f4;
    --selected-puzzle-color-light: #afd1ff;
    --lighter-table-row-color-light: lightgray;
    --tutorial-overlay-color-light: rgba(0, 0, 0, 0.5);
    --button-hover-color-light: #f7f7f7;
    --verified-blue-light: #8db896; /*#98c293  */
    --first-turn-color-light: #7b98e7;
    --second-turn-color-light: #a8ce7a;
    --third-turn-color-light: #edd58b;
    --fourth-turn-color-light: #f0af81;
    --fifth-turn-color-light: #F79999;
    --verified-text-color-light: white;
    --pyramid-logo-first-row-light: var(--first-turn-color-light);
    --pyramid-logo-second-row-light: #9ac37f;
    --pyramid-logo-third-row-light: var(--third-turn-color-light);
    --pyramid-logo-border-light: black;
    --start-button-color-light: var(--pyramid-logo-second-row-light);
    --completed-puzzle-indicator-color-light: #bf9b30; 
    --failed-puzzle-indicator-color-light: #cd1919;

    /* Dark mode colors */
    --body-background-color-dark: #121212;
    --overlay-background-color-dark: rgba(18, 18, 18, 0.9);
    --default-text-color-dark: rgb(220, 220, 220);
    --secondary-text-color-dark: rgb(140, 140, 140);
    --default-button-background-color-dark: rgb(100, 100, 100);
    --default-button-text-color-dark: white;
    --selected-color-dark: rgb(225, 225, 225);
    --cell-outline-color-dark: rgb(100, 100, 100);
    --banner-shadow-color-dark: rgb(250, 250, 250);
    --unavailable-calendar-color-dark: rgb(100, 100, 100);
    --selected-puzzle-color-dark: #7da2d7;
    --lighter-table-row-color-dark: gray;
    --tutorial-overlay-color-dark: rgba(100, 100, 100, 0.95);
    --button-hover-color-dark: #8c8c8c;
    --verified-blue-dark: #73987b;
    --first-turn-color-dark: #718ad0;
    --second-turn-color-dark: rgb(146, 182, 107);
    --third-turn-color-dark: #cfb56d;
    --fourth-turn-color-dark: #da915a;
    --fifth-turn-color-dark: #e18181;
    --verified-text-color-dark: rgb(220, 220, 220);
    --pyramid-logo-first-row-dark: var(--first-turn-color-light);
    --pyramid-logo-second-row-dark: var(--pyramid-logo-second-row-light);
    --pyramid-logo-third-row-dark: var(--third-turn-color-light);
    --pyramid-logo-border-dark: rgb(60, 60, 60);
    --start-button-color-dark: #83a56d;
    --completed-puzzle-indicator-color-dark: #bf9b30;
    --failed-puzzle-indicator-color-dark: #cd1919;

    /* Color variables, set to light by default. */
    --body-background-color: var(--body-background-color-light);
    --overlay-background-color: var(--overlay-background-color-light);
    --default-text-color: var(--default-text-color-light);
    --secondary-text-color: var(--secondary-text-color-light);
    --default-button-background-color: var(--default-button-background-color-light);
    --default-button-text-color: var(--default-button-text-color-light);
    --selected-color: var(--selected-color-light);
    --cell-outline-color: var(--cell-outline-color-light);
    --banner-shadow-color: var(--banner-shadow-color-light);
    --unavailable-calendar-color: var(--unavailable-calendar-color-light);
    --selected-puzzle-color: var(--selected-puzzle-color-light);
    --lighter-table-row-color: var(--lighter-table-row-color-light);
    --tutorial-overlay-color: var(--tutorial-overlay-color-light);
    --button-hover-color: var(--button-hover-color-light);
    --verified-blue: var(--verified-blue-light);
    --first-turn-color: var(--first-turn-color-light);
    --second-turn-color: var(--second-turn-color-light);
    --third-turn-color: var(--third-turn-color-light);
    --fourth-turn-color: var(--fourth-turn-color-light);
    --fifth-turn-color: var(--fifth-turn-color-light);
    --verified-text-color: var(--verified-text-color-light);
    --pyramid-logo-first-row: var(--pyramid-logo-first-row-light);
    --pyramid-logo-second-row: var(--pyramid-logo-second-row-light);
    --pyramid-logo-third-row: var(--pyramid-logo-third-row-light);
    --pyramid-logo-border: var(--pyramid-logo-border-light);
    --start-button-color: var(--start-button-color-light);
    --completed-puzzle-indicator-color: var(--completed-puzzle-indicator-color-light);
    --failed-puzzle-indicator-color: var(--failed-puzzle-indicator-color-light);
}

:root[data-theme='dark'] {
    --body-background-color: var(--body-background-color-dark);
    --overlay-background-color: var(--overlay-background-color-dark);
    --default-text-color: var(--default-text-color-dark);
    --secondary-text-color: var(--secondary-text-color-dark);
    --default-button-background-color: var(--default-button-background-color-dark);
    --default-button-text-color: var(--default-button-text-color-dark);
    --selected-color: var(--selected-color-dark);
    --cell-outline-color: var(--cell-outline-color-dark);
    --banner-shadow-color: var(--banner-shadow-color-dark);
    --unavailable-calendar-color: var(--unavailable-calendar-color-dark);
    --selected-puzzle-color: var(--selected-puzzle-color-dark);
    --lighter-table-row-color: var(--lighter-table-row-color-dark);
    --tutorial-overlay-color: var(--tutorial-overlay-color-dark);
    --button-hover-color: var(--button-hover-color-dark);
    --verified-blue: var(--verified-blue-dark);
    --first-turn-color: var(--first-turn-color-dark);
    --second-turn-color: var(--second-turn-color-dark);
    --third-turn-color: var(--third-turn-color-dark);
    --fourth-turn-color: var(--fourth-turn-color-dark);
    --fifth-turn-color: var(--fifth-turn-color-dark);
    --verified-text-color: var(--verified-text-color-dark);
    --pyramid-logo-first-row: var(--pyramid-logo-first-row-dark);
    --pyramid-logo-second-row: var(--pyramid-logo-second-row-dark);
    --pyramid-logo-third-row: var(--pyramid-logo-third-row-dark);
    --pyramid-logo-border: var(--pyramid-logo-border-dark);
    --start-button-color: var(--start-button-color-dark);
    --completed-puzzle-indicator-color: var(--completed-puzzle-indicator-color-dark);
    --failed-puzzle-indicator-color: var(--failed-puzzle-indicator-color-dark);
}

 html,
 body {
     margin: 0;
     overflow: hidden;
     width: 100%;
     height: 100%;
     user-select: none;
     -webkit-user-select: none;
     -moz-user-select: none;
     -ms-user-select: none;
     font-family: var(--main-font);
     color: var(--default-text-color);
     background-color: var(--body-background-color);
 }

 html {
     padding: var(--safe-area-inset-top) var(--safe-area-inset-right) var(--safe-area-inset-bottom) var(--safe-area-inset-left);
 }

 body {
    position: relative;
 }

 #root {
    height: 100%;
 }


/* Universally hide the scrollbar in WebKit and Webkit-derived browsers. */
 *::-webkit-scrollbar {
    display: none;
}

.cursor-pointer {
    cursor: pointer;
}

.full-screen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--overlay-background-color);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.none {
    display: none !important;
}


.ReactModal__Overlay {
    will-change: opacity;
    display: flex;
    flex-direction: column;
    inset: 0;
    position: fixed;
    align-items: center;
    justify-content: center;
      /* inset: var(--safe-area-inset-top) var(--safe-area-inset-right) var(--safe-area-inset-bottom) var(--safe-area-inset-left); */
  }

.ReactModal__Overlay.top-aligned-modal {
    justify-content: flex-start;
}

.ReactModal__Overlay.top-aligned-modal.below-banner-modal::before {
  content: '';
  flex: 0 0 calc(var(--safe-area-inset-top) + var(--banner-height));
}

.ReactModal__Overlay.top-aligned-modal .ReactModal__Content{
    position: relative;
}

.ReactModal__Overlay.right-aligned-modal {
    align-items: flex-end;
}

.ReactModal__Overlay.right-aligned-modal {
    align-items: flex-end;
}

.ReactModal__Content {
    will-change: transform, opacity;
}

.ReactModal__Overlay::before {
  content: '';
  flex: 0 0 var(--safe-area-inset-top);
}

.ReactModal__Overlay.centered-modal::after {
  content: '';
  flex: 0 0 var(--safe-area-inset-bottom);
}


a:visited, a:-webkit-any-link {
  color: inherit;
}

.bold {
  font-weight: bold;
}

* {
  -webkit-tap-highlight-color: transparent;
}

input {
  background-color: var(--body-background-color);
  box-shadow: none;
  border: 1px solid var(--default-text-color);
  color: var(--default-text-color);
}

.secondary-text {
    color: var(--secondary-text-color);
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,+DAAiE;IACjE,gBAAgB;IAChB,kBAAkB;EACpB;;AAEF;IACI,wBAAwB;IACxB,+DAAmE;IACnE,gBAAgB;IAChB,kBAAkB;EACpB;;AAEF;IACI,wBAAwB;IACxB,+DAAkE;IAClE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,+DAAoE;IACpE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,+DAAgE;IAChE,gBAAgB;IAChB,kBAAkB;EACpB;;;;;AAKF;IACI,qBAAqB;IACrB,oCAAoC;IACpC,qCAAqC;IACrC,4BAA4B;IAC5B,oCAAoC;IACpC,mCAAmC;IACnC,sBAAsB;IACtB,wCAAwC;IACxC,kBAAkB;IAClB,wBAAwB;IACxB,iCAAiC;IACjC,sCAAsC;IACtC,wBAAwB;IACxB,sDAAsD;;IAEtD,sBAAsB;IACtB,sCAAsC;IACtC,0DAA0D;IAC1D,iCAAiC;IACjC,gDAAgD;IAChD,kDAAkD;IAClD,wCAAwC;IACxC,6BAA6B;IAC7B,qCAAqC;IACrC,sCAAsC;IACtC,2CAA2C;IAC3C,sCAAsC;IACtC,0CAA0C;IAC1C,kDAAkD;IAClD,mCAAmC;IACnC,8BAA8B,EAAE,YAAY;IAC5C,iCAAiC;IACjC,kCAAkC;IAClC,iCAAiC;IACjC,kCAAkC;IAClC,iCAAiC;IACjC,kCAAkC;IAClC,6DAA6D;IAC7D,wCAAwC;IACxC,6DAA6D;IAC7D,kCAAkC;IAClC,gEAAgE;IAChE,iDAAiD;IACjD,8CAA8C;;IAE9C,qBAAqB;IACrB,qCAAqC;IACrC,sDAAsD;IACtD,6CAA6C;IAC7C,+CAA+C;IAC/C,0DAA0D;IAC1D,uCAAuC;IACvC,yCAAyC;IACzC,6CAA6C;IAC7C,8CAA8C;IAC9C,qDAAqD;IACrD,qCAAqC;IACrC,oCAAoC;IACpC,wDAAwD;IACxD,kCAAkC;IAClC,6BAA6B;IAC7B,gCAAgC;IAChC,4CAA4C;IAC5C,gCAAgC;IAChC,iCAAiC;IACjC,gCAAgC;IAChC,8CAA8C;IAC9C,4DAA4D;IAC5D,oEAAoE;IACpE,4DAA4D;IAC5D,2CAA2C;IAC3C,kCAAkC;IAClC,gDAAgD;IAChD,6CAA6C;;IAE7C,8CAA8C;IAC9C,2DAA2D;IAC3D,iEAAiE;IACjE,qDAAqD;IACrD,yDAAyD;IACzD,+EAA+E;IAC/E,mEAAmE;IACnE,6CAA6C;IAC7C,qDAAqD;IACrD,uDAAuD;IACvD,qEAAqE;IACrE,2DAA2D;IAC3D,+DAA+D;IAC/D,6DAA6D;IAC7D,qDAAqD;IACrD,2CAA2C;IAC3C,iDAAiD;IACjD,mDAAmD;IACnD,iDAAiD;IACjD,mDAAmD;IACnD,iDAAiD;IACjD,uDAAuD;IACvD,6DAA6D;IAC7D,+DAA+D;IAC/D,6DAA6D;IAC7D,uDAAuD;IACvD,qDAAqD;IACrD,iFAAiF;IACjF,2EAA2E;AAC/E;;AAEA;IACI,0DAA0D;IAC1D,gEAAgE;IAChE,oDAAoD;IACpD,wDAAwD;IACxD,8EAA8E;IAC9E,kEAAkE;IAClE,4CAA4C;IAC5C,oDAAoD;IACpD,sDAAsD;IACtD,oEAAoE;IACpE,0DAA0D;IAC1D,8DAA8D;IAC9D,4DAA4D;IAC5D,oDAAoD;IACpD,0CAA0C;IAC1C,gDAAgD;IAChD,kDAAkD;IAClD,gDAAgD;IAChD,kDAAkD;IAClD,gDAAgD;IAChD,sDAAsD;IACtD,4DAA4D;IAC5D,8DAA8D;IAC9D,4DAA4D;IAC5D,sDAAsD;IACtD,oDAAoD;IACpD,gFAAgF;IAChF,0EAA0E;AAC9E;;CAEC;;KAEI,SAAS;KACT,gBAAgB;KAChB,WAAW;KACX,YAAY;KACZ,iBAAiB;KACjB,yBAAyB;KACzB,sBAAsB;KACtB,qBAAqB;KACrB,6BAA6B;KAC7B,gCAAgC;KAChC,8CAA8C;CAClD;;CAEA;KACI,0HAA0H;CAC9H;;CAEA;IACG,kBAAkB;CACrB;;CAEA;IACG,YAAY;CACf;;;AAGD,0EAA0E;CACzE;IACG,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,uBAAuB;MACrB,8HAA8H;EAClI;;AAEF;IACI,2BAA2B;AAC/B;;AAEA;EACE,WAAW;EACX,iEAAiE;AACnE;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,uCAAuC;AACzC;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":["html {\n    box-sizing: border-box;\n}\n\n@font-face {\n    font-family: 'Quicksand';\n    src: url('./assets/fonts/Quicksand-Light.ttf') format('truetype');\n    font-weight: 300;\n    font-style: normal;\n  }\n\n@font-face {\n    font-family: 'Quicksand';\n    src: url('./assets/fonts/Quicksand-Regular.ttf') format('truetype');\n    font-weight: 400;\n    font-style: normal;\n  }\n\n@font-face {\n    font-family: 'Quicksand';\n    src: url('./assets/fonts/Quicksand-Medium.ttf') format('truetype');\n    font-weight: 500;\n    font-style: normal;\n  }\n  \n  @font-face {\n    font-family: 'Quicksand';\n    src: url('./assets/fonts/Quicksand-SemiBold.ttf') format('truetype');\n    font-weight: 600;\n    font-style: normal;\n  }\n  \n  @font-face {\n    font-family: 'Quicksand';\n    src: url('./assets/fonts/Quicksand-Bold.ttf') format('truetype');\n    font-weight: 700;\n    font-style: normal;\n  }\n\n\n\n\n:root {\n    --banner-height: 50px;\n    --main-font: 'Quicksand', sans-serif;\n    --incorrect-color: rgb(175, 175, 175);\n    --streak-color: 251, 145, 24;\n    --unsolved-color: rgb(255, 255, 255);\n    --selection-blue: rgb(50, 115, 246);\n    --unseen-blue: #3d88ed;\n    --victory-modal-gray: rgb(160, 160, 160);\n    --max-width: 500px;\n    --modal-max-width: 300px;\n    --turn-transition-duration: 500ms;\n    --half-turn-transition-duration: 250ms;\n    --letter-margin-rem: 0.3;\n    --turn-indicator-width: calc(min(2.3vw, 0.7rem) + 1px);\n\n    /* Light mode colors */\n    --body-background-color-light: #ffffff;\n    --overlay-background-color-light: rgba(255, 255, 255, 0.9);\n    --default-text-color-light: black;\n    --secondary-text-color-light: rgb(100, 100, 100);\n    --default-button-background-color-light: lightgray;\n    --default-button-text-color-light: black;\n    --selected-color-light: black;\n    --cell-outline-color-light: lightgray;\n    --banner-shadow-color-light: lightgray;\n    --unavailable-calendar-color-light: #f4f4f4;\n    --selected-puzzle-color-light: #afd1ff;\n    --lighter-table-row-color-light: lightgray;\n    --tutorial-overlay-color-light: rgba(0, 0, 0, 0.5);\n    --button-hover-color-light: #f7f7f7;\n    --verified-blue-light: #8db896; /*#98c293  */\n    --first-turn-color-light: #7b98e7;\n    --second-turn-color-light: #a8ce7a;\n    --third-turn-color-light: #edd58b;\n    --fourth-turn-color-light: #f0af81;\n    --fifth-turn-color-light: #F79999;\n    --verified-text-color-light: white;\n    --pyramid-logo-first-row-light: var(--first-turn-color-light);\n    --pyramid-logo-second-row-light: #9ac37f;\n    --pyramid-logo-third-row-light: var(--third-turn-color-light);\n    --pyramid-logo-border-light: black;\n    --start-button-color-light: var(--pyramid-logo-second-row-light);\n    --completed-puzzle-indicator-color-light: #bf9b30; \n    --failed-puzzle-indicator-color-light: #cd1919;\n\n    /* Dark mode colors */\n    --body-background-color-dark: #121212;\n    --overlay-background-color-dark: rgba(18, 18, 18, 0.9);\n    --default-text-color-dark: rgb(220, 220, 220);\n    --secondary-text-color-dark: rgb(140, 140, 140);\n    --default-button-background-color-dark: rgb(100, 100, 100);\n    --default-button-text-color-dark: white;\n    --selected-color-dark: rgb(225, 225, 225);\n    --cell-outline-color-dark: rgb(100, 100, 100);\n    --banner-shadow-color-dark: rgb(250, 250, 250);\n    --unavailable-calendar-color-dark: rgb(100, 100, 100);\n    --selected-puzzle-color-dark: #7da2d7;\n    --lighter-table-row-color-dark: gray;\n    --tutorial-overlay-color-dark: rgba(100, 100, 100, 0.95);\n    --button-hover-color-dark: #8c8c8c;\n    --verified-blue-dark: #73987b;\n    --first-turn-color-dark: #718ad0;\n    --second-turn-color-dark: rgb(146, 182, 107);\n    --third-turn-color-dark: #cfb56d;\n    --fourth-turn-color-dark: #da915a;\n    --fifth-turn-color-dark: #e18181;\n    --verified-text-color-dark: rgb(220, 220, 220);\n    --pyramid-logo-first-row-dark: var(--first-turn-color-light);\n    --pyramid-logo-second-row-dark: var(--pyramid-logo-second-row-light);\n    --pyramid-logo-third-row-dark: var(--third-turn-color-light);\n    --pyramid-logo-border-dark: rgb(60, 60, 60);\n    --start-button-color-dark: #83a56d;\n    --completed-puzzle-indicator-color-dark: #bf9b30;\n    --failed-puzzle-indicator-color-dark: #cd1919;\n\n    /* Color variables, set to light by default. */\n    --body-background-color: var(--body-background-color-light);\n    --overlay-background-color: var(--overlay-background-color-light);\n    --default-text-color: var(--default-text-color-light);\n    --secondary-text-color: var(--secondary-text-color-light);\n    --default-button-background-color: var(--default-button-background-color-light);\n    --default-button-text-color: var(--default-button-text-color-light);\n    --selected-color: var(--selected-color-light);\n    --cell-outline-color: var(--cell-outline-color-light);\n    --banner-shadow-color: var(--banner-shadow-color-light);\n    --unavailable-calendar-color: var(--unavailable-calendar-color-light);\n    --selected-puzzle-color: var(--selected-puzzle-color-light);\n    --lighter-table-row-color: var(--lighter-table-row-color-light);\n    --tutorial-overlay-color: var(--tutorial-overlay-color-light);\n    --button-hover-color: var(--button-hover-color-light);\n    --verified-blue: var(--verified-blue-light);\n    --first-turn-color: var(--first-turn-color-light);\n    --second-turn-color: var(--second-turn-color-light);\n    --third-turn-color: var(--third-turn-color-light);\n    --fourth-turn-color: var(--fourth-turn-color-light);\n    --fifth-turn-color: var(--fifth-turn-color-light);\n    --verified-text-color: var(--verified-text-color-light);\n    --pyramid-logo-first-row: var(--pyramid-logo-first-row-light);\n    --pyramid-logo-second-row: var(--pyramid-logo-second-row-light);\n    --pyramid-logo-third-row: var(--pyramid-logo-third-row-light);\n    --pyramid-logo-border: var(--pyramid-logo-border-light);\n    --start-button-color: var(--start-button-color-light);\n    --completed-puzzle-indicator-color: var(--completed-puzzle-indicator-color-light);\n    --failed-puzzle-indicator-color: var(--failed-puzzle-indicator-color-light);\n}\n\n:root[data-theme='dark'] {\n    --body-background-color: var(--body-background-color-dark);\n    --overlay-background-color: var(--overlay-background-color-dark);\n    --default-text-color: var(--default-text-color-dark);\n    --secondary-text-color: var(--secondary-text-color-dark);\n    --default-button-background-color: var(--default-button-background-color-dark);\n    --default-button-text-color: var(--default-button-text-color-dark);\n    --selected-color: var(--selected-color-dark);\n    --cell-outline-color: var(--cell-outline-color-dark);\n    --banner-shadow-color: var(--banner-shadow-color-dark);\n    --unavailable-calendar-color: var(--unavailable-calendar-color-dark);\n    --selected-puzzle-color: var(--selected-puzzle-color-dark);\n    --lighter-table-row-color: var(--lighter-table-row-color-dark);\n    --tutorial-overlay-color: var(--tutorial-overlay-color-dark);\n    --button-hover-color: var(--button-hover-color-dark);\n    --verified-blue: var(--verified-blue-dark);\n    --first-turn-color: var(--first-turn-color-dark);\n    --second-turn-color: var(--second-turn-color-dark);\n    --third-turn-color: var(--third-turn-color-dark);\n    --fourth-turn-color: var(--fourth-turn-color-dark);\n    --fifth-turn-color: var(--fifth-turn-color-dark);\n    --verified-text-color: var(--verified-text-color-dark);\n    --pyramid-logo-first-row: var(--pyramid-logo-first-row-dark);\n    --pyramid-logo-second-row: var(--pyramid-logo-second-row-dark);\n    --pyramid-logo-third-row: var(--pyramid-logo-third-row-dark);\n    --pyramid-logo-border: var(--pyramid-logo-border-dark);\n    --start-button-color: var(--start-button-color-dark);\n    --completed-puzzle-indicator-color: var(--completed-puzzle-indicator-color-dark);\n    --failed-puzzle-indicator-color: var(--failed-puzzle-indicator-color-dark);\n}\n\n html,\n body {\n     margin: 0;\n     overflow: hidden;\n     width: 100%;\n     height: 100%;\n     user-select: none;\n     -webkit-user-select: none;\n     -moz-user-select: none;\n     -ms-user-select: none;\n     font-family: var(--main-font);\n     color: var(--default-text-color);\n     background-color: var(--body-background-color);\n }\n\n html {\n     padding: var(--safe-area-inset-top) var(--safe-area-inset-right) var(--safe-area-inset-bottom) var(--safe-area-inset-left);\n }\n\n body {\n    position: relative;\n }\n\n #root {\n    height: 100%;\n }\n\n\n/* Universally hide the scrollbar in WebKit and Webkit-derived browsers. */\n *::-webkit-scrollbar {\n    display: none;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n.full-screen-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--overlay-background-color);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10000;\n}\n\n.none {\n    display: none !important;\n}\n\n\n.ReactModal__Overlay {\n    will-change: opacity;\n    display: flex;\n    flex-direction: column;\n    inset: 0;\n    position: fixed;\n    align-items: center;\n    justify-content: center;\n      /* inset: var(--safe-area-inset-top) var(--safe-area-inset-right) var(--safe-area-inset-bottom) var(--safe-area-inset-left); */\n  }\n\n.ReactModal__Overlay.top-aligned-modal {\n    justify-content: flex-start;\n}\n\n.ReactModal__Overlay.top-aligned-modal.below-banner-modal::before {\n  content: '';\n  flex: 0 0 calc(var(--safe-area-inset-top) + var(--banner-height));\n}\n\n.ReactModal__Overlay.top-aligned-modal .ReactModal__Content{\n    position: relative;\n}\n\n.ReactModal__Overlay.right-aligned-modal {\n    align-items: flex-end;\n}\n\n.ReactModal__Overlay.right-aligned-modal {\n    align-items: flex-end;\n}\n\n.ReactModal__Content {\n    will-change: transform, opacity;\n}\n\n.ReactModal__Overlay::before {\n  content: '';\n  flex: 0 0 var(--safe-area-inset-top);\n}\n\n.ReactModal__Overlay.centered-modal::after {\n  content: '';\n  flex: 0 0 var(--safe-area-inset-bottom);\n}\n\n\na:visited, a:-webkit-any-link {\n  color: inherit;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n* {\n  -webkit-tap-highlight-color: transparent;\n}\n\ninput {\n  background-color: var(--body-background-color);\n  box-shadow: none;\n  border: 1px solid var(--default-text-color);\n  color: var(--default-text-color);\n}\n\n.secondary-text {\n    color: var(--secondary-text-color);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
